import React from 'react'
import PageHeader from '../shared/pageHeader/PageHeader'
import Footer from '../shared/Footer'
import Header from '../shared/header/Header'
import NavigationMenu from '../shared/navigationMenu/NavigationMenu'
import Member2Header from './Member2Header'
import MemberCreate from './MemberCreate'

const EditMember = () => {
    return (
        <>

            <Header />
            <NavigationMenu />
            <main className="nxl-container">
                <div className="nxl-content">
                    <PageHeader>
                        <Member2Header />
                    </PageHeader>

                    <div className='main-content'>
                        <div className='row'>
                            <MemberCreate />
                        </div>
                    </div>
                    <Footer />
                </div>
            </main>

        </>
    )
}

export default EditMember